"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertWatcherActionsContext = exports.AlertWatcherContext = exports.AlertWatcherControllerInner = exports.AlertWatcherController = void 0;
const lib_storage_1 = require("@opsbase/lib-storage");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelf"));
const useWhenSelfChanges_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useWhenSelfChanges"));
const useAlerts_1 = __importDefault(require("@opsbase/react-gql-hooks/alert/useAlerts"));
const useInterval_1 = __importDefault(require("@opsbase/react-hooks/useInterval"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const sortedUniqBy_1 = __importDefault(require("lodash/sortedUniqBy"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const CHECK_EVERY = 1000 * 60;
const LOCALSTORAGE_KEY = 'alert_readit';
function AlertWatcherController({ children }) {
    const { hasAlerts } = (0, useAppState_1.default)();
    if (!hasAlerts)
        return children;
    return react_1.default.createElement(AlertWatcherControllerInner, null, children);
}
exports.AlertWatcherController = AlertWatcherController;
function AlertWatcherControllerInner({ children }) {
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const alerts = (0, react_1.useRef)({});
    const reddit = (0, react_1.useRef)({});
    const self = (0, useSelf_1.default)();
    const lastCheckedDate = (0, react_1.useRef)();
    const [sentAfter, setSentAfter] = (0, react_1.useState)((0, moment_timezone_1.default)().subtract(1, 'day').toDate());
    const { loading, data } = (0, useAlerts_1.default)({
        variables: { sentAfter },
        skip: !self.isStaff,
    });
    (0, useInterval_1.default)(() => {
        setSentAfter(lastCheckedDate.current);
        lastCheckedDate.current = new Date();
    }, CHECK_EVERY);
    (0, useWhenSelfChanges_1.default)(() => {
        setSentAfter((0, moment_timezone_1.default)().subtract(1, 'day').toDate());
        lastCheckedDate.current = new Date();
    });
    const storeReddit = (0, react_1.useMemo)(() => () => {
        (0, lib_storage_1.setStoredValue)(LOCALSTORAGE_KEY, JSON.stringify(reddit.current));
    }, []);
    // Initialise by loading Read flags from local storage
    (0, react_1.useEffect)(() => {
        try {
            reddit.current = JSON.parse((0, lib_storage_1.getStoredValue)(LOCALSTORAGE_KEY) || '{}');
        }
        catch (_a) { }
        if (!reddit.current)
            reddit.current = {};
        Object.keys(reddit.current).forEach(id => {
            if ((0, moment_timezone_1.default)(reddit.current[id]).isBefore((0, moment_timezone_1.default)().subtract(2, 'days')))
                delete reddit.current[id];
        });
        (0, lib_storage_1.setStoredValue)(LOCALSTORAGE_KEY, JSON.stringify(reddit.current));
    }, []);
    // Handle Alerts Loading
    (0, react_1.useEffect)(() => {
        if (!loading && data && data.length) {
            let newAlerts = [...data, ...Object.values(alerts.current)];
            // Sort data and remove duplicates
            newAlerts = (0, sortedUniqBy_1.default)((0, sortBy_1.default)(newAlerts, d => (0, moment_timezone_1.default)().diff(d.sentDate)), getUniqKeyForAlert);
            // If the data has changed, lets push it
            alerts.current = newAlerts.reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.id]: c })), {});
            setCtxChanged(new Date());
        }
    }, [loading, data]);
    const markAsRead = (0, react_1.useMemo)(() => (id) => {
        reddit.current[id] = new Date();
        storeReddit();
        setCtxChanged(new Date());
    }, [storeReddit]);
    const markAsUnread = (0, react_1.useMemo)(() => (id) => {
        delete reddit.current[id];
        storeReddit();
        setCtxChanged(new Date());
    }, [storeReddit]);
    const markAllAsRead = (0, react_1.useMemo)(() => () => {
        Object.keys(alerts.current).forEach(id => (reddit.current[id] = new Date()));
        storeReddit();
        setCtxChanged(new Date());
    }, [storeReddit]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        markAsRead,
        markAsUnread,
        markAllAsRead,
    }), [markAsRead, markAsUnread, markAllAsRead]);
    const ctx = (0, react_1.useMemo)(() => {
        return {
            alerts: Object.values(alerts.current),
            readIds: Object.keys(reddit.current),
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(exports.AlertWatcherActionsContext.Provider, { value: actionsCtx },
        react_1.default.createElement(exports.AlertWatcherContext.Provider, { value: ctx }, children)));
}
exports.AlertWatcherControllerInner = AlertWatcherControllerInner;
exports.default = AlertWatcherController;
exports.AlertWatcherContext = react_1.default.createContext(null);
exports.AlertWatcherActionsContext = react_1.default.createContext(null);
function getUniqKeyForAlert(a) {
    return (a.actionType +
        '_' +
        (a.relatedIssue ? a.relatedIssue.id : '') +
        (a.relatedOp ? a.relatedOp.id : ''));
}
